$(document).ready(function () {
  $('[data-ez-slider]').each(function () {
    var $slider = $(this);

    if ($slider.hasClass('flickity-enabled')) return;

    $slider.flickity({
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      imagesLoaded: true
    });
  });
});